module.exports = __webpack_public_path__ + "static/media/zuima.42876ef2.jpg";